import { event } from "model/notification";

const notificationText = () => {
  return event(
    `a map?`,
    "the stranger's map. its lines and marks promising untold stories.",
  );
};

const attempt = (context) => {
  const { party } = context;

  const result = {
    success: true,
    gain: {
      roadMap: 1,
    },
    cost: {},
  };

  party.history.delta({ roadMap: 1 }, context);

  return result;
};

const takeMap = (notifyDone) => ({
  title: "Take paper",
  enabled: () => true,
  execute: (context) => {
    const result = attempt(context);

    const notification = notificationText(result);

    notifyDone();

    return { result, notification };
  },
  tooltips: [["Map"]],
});

export default takeMap;
